import { ImportMetaEnv } from "@/vite-env";

// TODO - нужно настроить правило eslint для запрета использования
// import.meta.env где либо, кроме этого файла

const environmentKeys = [
    "VITE_APP_API",
    "VITE_KEYCLOAK_API",
    "VITE_KEYCLOAK_REALM",
    "VITE_KEYCLOAK_CLIENT_ID",
    "VITE_LICENSE_SECRET",
    "VITE_USER_AGREEMENT_URL",
    "VITE_USER_TERMS_AND_CONDITIONS_URL",
    "VITE_DATA_PROCESSING_CONSENT_URL",
    "VITE_COOKIE_CONSENT_URL",
    "VITE_YA_CAPTCHA_KEY",
    "VITE_DADATA_API_KEY",
    "VITE_ATOL_ID_URL",
    "VITE_ATOL_ROLES_URL",
    "VITE_APP_ENVIRONMENT",
    "VITE_LICENSING_PROFILE_URL",
] as const;

function exhaustiveKeys<T extends readonly string[], U>(
    arr: [keyof U] extends [T[number]]
        ? [T[number]] extends [keyof U]
            ? T
            : never
        : never,
): T {
    return arr;
}

const checkedEnvironmentKeys = exhaustiveKeys<
    typeof environmentKeys,
    ImportMetaEnv
>(environmentKeys);

export const environment = {} as ImportMetaEnv;
for (const key of checkedEnvironmentKeys) {
    Object.defineProperty(environment, key, {
        get() {
            return window.__$environment?.[key] ?? import.meta.env[key];
        },
    });
}
